import { Element } from 'types';

export const randomString = () => (Math.random() + 1).toString(36).substring(4);
export const generateId = (elementId: Element['id']) => `${ elementId }_${ randomString() }`;
